/**
 * SHER-782 — does this failed submission update mean "the server wants an edit reason"?
 *
 * Both surfaces that save a submission edit (FillSurvey and ShowSingleSubmissionPatient)
 * have to answer this, and they answered it differently: FillSurvey recovered by opening
 * the reason modal, ShowSingleSubmissionPatient had no branch at all and fell through to
 * a raw alert(), leaving the clinician no way to supply the reason the API was asking for.
 * Two copies of one rule is what let them drift, so the rule lives here and both call it.
 *
 * The API used to signal this with the numeric errorCode 5, which it also returns for
 * "Investigation reference not found", "File cannot be empty!" and other unrelated
 * failures — matching on it could open the edit-reason modal for something that has
 * nothing to do with edit reasons. It now sends the distinct string EDIT_REASON_REQUIRED,
 * alongside the NOT_ORIGINAL_AUTHOR / PASSWORD_REQUIRED codes it already used.
 *
 * The legacy numeric code and the exact message are still accepted so a client newer than
 * the API it talks to keeps working during a staged deploy.
 */

export const EDIT_REASON_REQUIRED = 'EDIT_REASON_REQUIRED';

export function isEditReasonRequiredError(error: any): boolean {
    if (!error) {
        return false;
    }
    const code = error.errorCode;
    if (code === EDIT_REASON_REQUIRED) {
        return true;
    }
    // Legacy API: numeric 5 plus the exact message, since 5 alone is ambiguous.
    const message = error.errorMessage ?? error.message;
    return code === 5 && typeof message === 'string' && message.startsWith('Edit reason is required');
}
